module.exports = __webpack_public_path__ + "img/MobileImage3_en.4149017f.png";